import React from 'react';

const TradingViewLiveChart = ({ symbol = "NASDAQ:BTCUSD" }) => {
  return (
    <div style={{ display: "flex", justifyContent: "center", width: "100%", marginBottom: "20px" }}>
      <iframe
        src={`https://s.tradingview.com/widgetembed/?frameElementId=tradingview-widget&symbol=${symbol}&interval=1&theme=dark&style=1&locale=en&toolbarbg=f1f3f6&enable_publishing=false&hide_side_toolbar=false&allow_symbol_change=true`}
        width="100%"
        height="400px"
        style={{ border: "none", maxWidth: "800px" }} // Max width ensures it doesn’t stretch too much
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default TradingViewLiveChart;
